import Utils from "../../services/Utils.js";
import { getLiveMatch, getLiveStreamLink } from "../../js/api/liveMatch.js";
import {
    getInsideSingleColumn,
    getSingleColumnModule,
} from "../templates/singleColumnModule.js";
import TranslationService, { _t } from "../../services/TranslationService.js";
import Timeline from "../components/Timeline.js";
import { getUserGroup, transformSingleCoef } from "../../services/UserGroup.js";
import { parseResultList } from "../templates/live-games.js";

var gameId = 0;
let groupMatchHomeName = "";
let groupMatchAwayName = "";
let gameApiID = null;
let lang = localStorage.getItem('lang') ?? TranslationService.defaultLang;
let multipeResults = '';
let sportFieldId = null;
let LiveMatch = {
    render: async () => {
        let upDownMarkets = [12, 16];
        let oneTwo = [7, 8, 9, 18];
        let request = Utils.parseRequestURL();
        if (request.query && request.query.sportid) {
            localStorage.setItem("inplay-sportid", request.query.sportid);
        }

        sportFieldId = localStorage.getItem("inplay-sportid");

        gameId = request.id;
        let groupMatches = await getLiveMatch(request.id);

        let groupMatchView = "";
        let matchView = "";
        let groupMatchDate = "";
        let scrollMeContent = "";
        let result = "";

        let liveStreamId = null;
        
        if (!groupMatches.length) {
            window.history.back();
            return;
        }

        try {
            if (groupMatches.length > 0) {
                liveStreamId = groupMatches[0][0].stream_id;
                gameApiID = groupMatches[0][0].game_api_id;
                multipeResults = parseResultList(groupMatches[0][0].result, groupMatches[0][0].result_list, false, sportFieldId);
            }
        } catch { }

        groupMatchHomeName = `${groupMatches[0][0].home_team}`;
        groupMatchAwayName = `${groupMatches[0][0].away_team}`;
        groupMatchDate = `${groupMatches[0][0].game_date}`;
        result = groupMatches[0][0].result;

        if (!(groupMatches.length == 1 && groupMatches[0].length == 1 && !groupMatches[0][0].odd)) {
            let acc = groupMatches.map(function (item) {
                return {
                    market_category_id: item[0].market_category_id,
                    mainCategory: item[0].mainCategory,
                    mainCategoryID: item[0].mainCategoryID,
                    marketId: item[0].market_category_id ? -1 : item[0].market_id,
                };
            });

            const uniqueCategories = [];

            $.each(acc, function (i, el) {
                const res = uniqueCategories.find((a) => a.market_category_id == el.market_category_id && a.marketId == el.marketId);
                if (!res) uniqueCategories.push(el);
            });

            uniqueCategories.forEach((category) => {
                let activeClass = "hidden";
                // console.log(category);
                if (category.mainCategory && category.mainCategoryID) {
                    if (scrollMeContent == "") activeClass = "active";
                    if (!scrollMeContent.includes(`data-target="${category.mainCategoryID}-module"`)) {
                        scrollMeContent += `<a class="singleMatchCatBtn ${!category.mainCategoryID || category.mainCategoryID == '33' ? "active" : "hidden"}" data-target="${category.mainCategoryID}-module">${_t(category.mainCategory)}</a>`;
                    }
                }
                matchView = "";
                const a = groupMatches.filter((a) => (a[0].market_category_id == category.market_category_id && a[0].market_id == category.marketId) || (a[0].market_category_id == category.market_category_id && category.marketId == -1));

                let counter = a[0].length;
                if (a[0][0].special_value && a[0][0].special_value != "") {
                    counter += 1;
                }
                let classDescription = "";
                switch (counter) {
                    case 1:
                        classDescription = "oneColumns";
                        break;
                    case 2:
                        classDescription = "twoColumns";
                        break;
                    case 3:
                        classDescription = "threeColumns";
                        break;
                    case 4:
                        classDescription = "fourColumns";
                        break;
                    default:
                        break;
                }
                if (a.length > 1) {
                    matchView += `<div class="singleHeaderHolderLabel">`;
                    if (a[0][0].special_value && a[0][0].special_value != "") {
                        matchView += `<div class="singleHeaderLabel ${classDescription}"></div>`;
                    }
                    if (a[0][0]) {
                        if (a[0][0].type_of_column == 4) {
                            matchView += `<div class="singleHeaderLabel ${classDescription}">1</div>`;
                        } else if (upDownMarkets.includes(a[0][0].market_category_id)) {
                            matchView += `<div class="singleHeaderLabel ${classDescription}">${_t('Lart')}</div>`;
                        } else if (oneTwo.includes(a[0][0].market_category_id)) {
                            matchView += `<div class="singleHeaderLabel ${classDescription}">${groupMatchHomeName}</div>`;
                        } else {
                            matchView += `<div class="singleHeaderLabel ${classDescription}">${_t('Lart')}</div>`;
                        }
                    }
                    if (a[0][1]) {
                        if (a[0][0].type_of_column == 4) {
                            matchView += `<div class="singleHeaderLabel ${classDescription}">X</div>`;
                        } else if (upDownMarkets.includes(a[0][1].market_category_id)) {
                            matchView += `<div class="singleHeaderLabel ${classDescription}">X</div>`;
                        } else if (oneTwo.includes(a[0][1].market_category_id)) {
                            matchView += `<div class="singleHeaderLabel ${classDescription}">${classDescription == "fourColumns" ? "X" : `${groupMatchAwayName}`}</div>`;
                        } else {
                            matchView += `<div class="singleHeaderLabel ${classDescription}">${classDescription == "fourColumns" ? _t("Saktë") : _t("Poshtë")}</div>`;
                        }
                    }
                    if (a[0][0].type_of_column == 4) {
                        matchView += `<div class="singleHeaderLabel ${classDescription}">2</div>`;
                    } else if (a[0][2]) {
                        matchView += `<div class="singleHeaderLabel ${classDescription}">${classDescription == "fourColumns" && oneTwo.includes(a[0][1].market_category_id) ? `${groupMatchAwayName}` : _t("Poshtë")}</div>`
                    }
                    matchView += ` </div>`;
                }

                a.forEach((groupMatch) => {
                    if (groupMatch[0].special_value && groupMatch[0].special_value != "") {
                        if (!groupMatch[0].market.includes("Larte Poshte me Pike") && groupMatch[0].market.includes("Nr i gameve ne Setin") ){
                            matchView += `<div class="singleColumnModule labelBtn ${groupMatch[0].special_value == '1.5' ? 'pushMeSecond' : ''} ${groupMatch[0].special_value == '0.5' ? 'pushMeFirst' : ''} ${classDescription}">
                                <span>${groupMatch[0].special_value}</span>
                            </div>`;
                        }
                    }
                    groupMatch.forEach((match) => {
                        if (match.mainCategoryID == '33' && match.market == 'Numri i Golave ne Ndeshje' && (match.market_option == 'Lart 1.5' || match.market_option == 'Poshte 1.5')) {
                            matchView += `<div class="singleColumnModule bettingBtn pushMeSecond ${classDescription} ${match.id}${match.special_value && match.special_value != "" ? "-span" : ``}" 
                            match-is-live="1" 
                            match-market-option="${match.market_option}" 
                            match-market="${match.market}" 
                            match-home-name="${match.home_team}" 
                            match-away-name="${match.away_team}"
                            match-odd="${(Math.floor((parseFloat(match.odd) + Number.EPSILON) * 100) / 100).toFixed(2)}" 
                            game-id="${request.id}" 
                            bet-id="${match.id}">
                                ${match.special_value && match.special_value != "" ? "" : `<span>${_t(match.market_option)}</span>`}
                                <span>${(Math.floor((parseFloat(match.odd) + Number.EPSILON) * 100) / 100).toFixed(2)}</span>
                        </div>`;
                        } else if (match.mainCategoryID == '33' && match.market == 'Numri i Golave ne Ndeshje' && (match.market_option == 'Lart 0.5' || match.market_option == 'Poshte 0.5')) {
                            matchView += `<div class="singleColumnModule bettingBtn pushMeFirst ${classDescription} ${match.id}${match.special_value && match.special_value != "" ? "-span" : ``}" 
                            match-is-live="1" match-market-option="${match.market_option}" 
                            match-market="${match.market}" 
                            match-home-name="${match.home_team}" 
                            match-away-name="${match.away_team}" 
                            match-odd="${(Math.floor((parseFloat(match.odd) + Number.EPSILON) * 100) / 100).toFixed(2)}" 
                            game-id="${request.id}" 
                            bet-id="${match.id}">
                                ${match.special_value && match.special_value != "" ? "" : `<span>${_t(match.market_option)}</span>`}
                                <span>${(Math.floor((parseFloat(match.odd) + Number.EPSILON) * 100) / 100).toFixed(2)}</span>
                        </div>`;
                        } else {
                            matchView += `<div class="singleColumnModule bettingBtn ${classDescription} ${match.id}${match.special_value && match.special_value != "" ? "-span" : ``}" 
                            match-is-live="1" 
                            match-market-option="${match.market_option}" 
                            match-market="${match.market}" 
                            match-home-name="${match.home_team}" 
                            match-away-name="${match.away_team}" 
                            match-odd="${(Math.floor((parseFloat(match.odd) + Number.EPSILON) * 100) / 100).toFixed(2)}" 
                            game-id="${request.id}" 
                            bet-id="${match.id}">
                            ${match.market.includes("Larte Poshte me Pike") || match.market.includes("Nr i gameve ne Setin") ? 
                                (match.special_value && (match.special_value !== "" && match.special_value !== null) ? `<span>${_t(match.market_option)}</span>` : `<span>${_t(match.market_option)}</span>`) : 
                                (match.special_value && match.special_value != "" ? "" : `<span>${_t(match.market_option)}</span>`)
                            }
                            <span>${(Math.floor((parseFloat(match.odd) + Number.EPSILON) * 100) / 100).toFixed(2)}</span>
                        </div>`;
                        }
                    });
                    if (!category.market_category_id) {
                        groupMatchView +=
                            `<div class="singleMatchBetModuleGroup ${!category.mainCategoryID || category.mainCategoryID == '33' ? "active" : "hidden"}"  data-content="${category.mainCategoryID}-module"  id="${groupMatch[0].market_id}">
                                <div class="singleMatchBetModuleGroupHeader">
                                    <span class="titleMarketSearch">${_t(groupMatch[0].market)}</span>
                                </div>
                            <div class="singleMatchBetModuleGroupContent">
                                ${matchView}
                            </div>
                        </div>`;
                        matchView = "";
                    }
                });

                if (category.market_category_id && category.market_category_id > 0) {
                    const uniqueMarkets = groupMatches.filter((a) => a && a[0] && a[0].market_category_id == category.market_category_id).map((item) => item[0].market_id);
                    const marketsClass = uniqueMarkets.join(" ");
                    groupMatchView += `<div class="singleMatchBetModuleGroup ${marketsClass} ${activeClass} ${a[0][0].market == 'Numri i Golave ne Ndeshje' ? 'fixThis' : ''}"  data-content="${a[0][0].mainCategoryID}-module">
                        <div id="${a[0][0].market_id}" class="contentMarketNull"> 
                            <div class="singleMatchBetModuleGroupHeader">
                                <span class="titleMarketSearch">${_t(a[0][0].market)}</span>
                            </div>
                            <div class="singleMatchBetModuleGroupContent">
                                ${matchView}
                            </div>
                        </div>
                    </div>`;
                }
            });
        }

        let view = /*html*/ `
            <div class="match-container" sport-id="${sportFieldId}">
                <div class="fieldStaticHolder">
                    <div class="singleMatchTitle liveSingleMatch ">
                        <div class="singleMatchScrolLMeName" >
                            <div class="singleCategoryTitle">
                                <a>Soccer / England</a>
                            </div>
                            <span class="matchVersusName">/ ${groupMatchHomeName} vs ${groupMatchAwayName}</span>
                            ${
                                (['2', '5', '20'].includes(sportFieldId)) ?
                                `
                                <div class="matchVersusName multiple-results">
                                    <div class="players">
                                        <div>${groupMatchHomeName}</div>
                                        <div>${groupMatchAwayName}</div>
                                    </div>
                                    <div class="results">
                                        ${multipeResults}
                                    </div>
                                </div>
                                ` :
                                `
                                <span class="matchVersusName mobileMatch">
                                    <span>${groupMatchHomeName}</span><i> <b>${result.split("-")[0]}</b> <b>${result.split("-")[1]}</b></i><span>${groupMatchAwayName}</span>
                                </span>
                                `
                            }
                            <span class="dateMobileHiden">${groupMatchDate}</span>
                            <a class="backBtn">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg>
                            </a>
                        </div>
                    </div>
                    <span class="showDateMobile liveSingle">${groupMatchDate}</span>
                    <div class="singleMatchWrapper">
                        <div class="singleFieldView liveInfoActive">
                            <div class="singleFieldButtons">
                                <a class="singleFieldButton liveInfoBtn">${_t('Live Info')}</a>
                            </div>
                            <div class="singleMatchField" style="display: none !important;">
                                <div class="singleMatchHolder">
                                    <div class="singleMatchFieldHeader">
                                        <span class="singleMatchRealTime">73:51</span>
                                        <div class="singleMatchFieldIcon">
                                            <div class="icon iconCorner"></div>
                                            <div class="icon yellowCard"></div>
                                            <div class="icon redCard"></div>
                                            <div class="icon goalCard"></div>
                                        </div>
                                    </div>
                                    <div class="singleMatchFieldContent">
                                        <div class="singleMatchFieldRow">
                                            <div class="fieldHomeName">
                                                <span>${groupMatchHomeName}</span>
                                            </div>
                                            <div class="matchFieldTable">
                                                <span class="cornerLabel">0</span>
                                                <span class="yellowCardLabel">1</span>
                                                <span class="redCardLabel">0</span>
                                                <span class="goalCardLabel">0</span>
                                            </div>
                                        </div>
                                        <div class="singleMatchFieldRow">
                                            <div class="fieldHomeName">
                                                <span>${groupMatchAwayName}</span>
                                            </div>
                                            <div class="matchFieldTable">
                                                <span class="cornerLabel">4</span>
                                                <span class="yellowCardLabel">1</span>
                                                <span class="redCardLabel">0</span>
                                                <span class="goalCardLabel">0</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="singleMatchLiveField" ${sportFieldId == 20 ? 'hidden' : ''}>
                                ${liveStreamId ? `
                                    <div class="liveMatchButtons">
                                        <a href="#" class="liveMatchBtn active" data-show="live-field">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-divide-square" style="transform: rotate(90deg)"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line><line x1="12" y1="8" x2="12" y2="8"></line></svg>
                                        </a>
                                        <a href="#" class="liveMatchBtn" data-show="live-stream" data-link="${liveStreamId}">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-monitor"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1='33' x2="12" y2="21"></line></svg>
                                        </a>
                                    </div>
                                ` : ""}
                                <div class="live-field">
                                    ${sportFieldId == 1 ? `<iframe id="iframe" src="https://${location.host}/betting_p2p/a.html?id=${gameId}&lng=${lang}" scrolling="no"></iframe>` : ""}
                                    ${sportFieldId == 2 ? `<iframe id="basketballIframe" src="https://365ecco365.co/betting_p2p/c.html?id=${gameId}&lng=${lang}" scrolling="no"></iframe>` : ""}
                                    ${sportFieldId == 5 ? `<iframe id="tennisIframe" src="https://365ecco365.co/betting_p2p/b.html?id=${gameId}&lng=${lang}" scrolling="no"></iframe>` : ""}
                                    ${sportFieldId == 16 ? `<img src="img/americanfootball.jpg" style="width: 100%;height: 80%;object-fit: cover;top: calc(30% + 25px);object-position: center center;" />` : ""}
                                </div>
                                ${liveStreamId ? `<div class="live-stream" style="display: none;"></div>` : ""}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="singleMatchBetModule m-t-240 singleFirstCatContainer active" style="display: inherit;" id="${gameId}-content">
                    <div class="timeline-wrapper"></div>
                        <div class="singleMatchSearchMarkets" hidden>
                            <input type="text" id="searchMarketsId" placeholder="${_t('Search Market')}">
                        </div>
                        <div class="newCatHolder" style = "position: relative; float: left; margin-bottom: 0;" >
                            <div class="slideMe" style="width: 100%; float: left; overflow-x: auto; height: auto; padding-right: 0">
                                <div class="scroller" style=" float: left;">
                                    ${scrollMeContent}
                                </div>
                            </div>
                            <span class="expander" game-api-id="${gameApiID}" style="position: absolute; right: -1px; padding: 8px; z-index: 2; top: 0; margin-top: 0;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-clock"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                            </span>
                        </div>
                        <div id="fixViewOn">
                            ${groupMatchView}
                        </div>
                    </div>
                </div>
            `;
        return view;
    },
    after_render: async (socket) => {
        let groupMatches;
        let request = Utils.parseRequestURL();

        let hasChanged = false;
        let marketIdShown = false;
        let lastActive = $('body .singleMatchCatBtn.active').attr('data-target');

        $('body .fixThis .singleMatchBetModuleGroupContent').each(function (i, item) {
            $(item).children('.pushMeFirst').wrapAll('<div class="groupRender first"></div>');
            $(item).children('.pushMeSecond').wrapAll('<div class="groupRender second"></div>');
            $(item).children('.pushMeSecond').wrapAll('<div class="groupRender third"></div>');
        });
        $('body .fixThis .singleMatchBetModuleGroupContent').each(function (i, item) {
            let firstItemGroup = $(item).children('.first');
            let secondItemGroup = $(item).children('.second');
            let thirdItemGroup = $(item).children('.third');
            let titleHeader = $(item).children('.singleHeaderHolderLabel');

            $(item).children('.first').remove();
            $(item).children('.second').remove();
            $(item).children('.third').remove();

            $(item).prepend(thirdItemGroup);
            $(item).prepend(secondItemGroup);
            $(item).prepend(firstItemGroup);
            $(item).prepend(titleHeader);
        });

        $("body").on("click", ".singleMatchCatBtn", function (e) {
            $("body .singleMatchCatBtn").removeClass("active");
            $("body .singleMatchBetModuleGroup").removeClass("active");
            $("body .singleMatchBetModuleGroup").addClass("hidden");
            lastActive = $(e.currentTarget).attr('data-target');
            $(e.currentTarget).addClass("active");
            let putTriggerContent = $(e.currentTarget).attr("data-target");
            $("body .singleMatchBetModuleGroup").each(function (i, item) {
                if (
                    $(item).attr("data-content") == putTriggerContent ||
                    (putTriggerContent == "17-module")
                ) {
                    $(item).addClass("active");
                    $(item).removeClass("hidden");
                }
            });
        });

        function delay(callback, ms) {
            var timer = 0;
            return function () {
                var context = this,
                    args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    callback.apply(context, args);
                }, ms || 0);
            };
        }

        $("body").on(
            "keyup",
            "#searchMarketsId",
            delay(async function (e) {
                let marketMatchText = $("#searchMarketsId").val().toLowerCase();
                console.log(marketMatchText);

                if (marketMatchText == "") {
                    $(".removeItem").removeClass("removeItem");
                } else {
                    $("body .titleMarketSearch").each(function (i, item) {
                        let valueOfMarket = $(item).text().toLowerCase();
                        console.log(item, ";item");
                        console.log(valueOfMarket, "itemi i kerkuarrr");
                        if (!valueOfMarket.includes(marketMatchText)) {
                            $(item)
                                .parent(".singleMatchBetModuleGroupHeader")
                                .parent(".contentMarketNull")
                                .parent(".singleMatchBetModuleGroup ")
                                .addClass("removeItem");
                            $(item)
                                .parent(".singleMatchBetModuleGroupHeader")
                                .parent(".singleMatchBetModuleGroup ")
                                .addClass("removeItem");
                        } else {
                            $(item)
                                .parent(".singleMatchBetModuleGroupHeader")
                                .parent(".contentMarketNull")
                                .parent(".singleMatchBetModuleGroup ")
                                .removeClass("removeItem");
                            $(item)
                                .parent(".singleMatchBetModuleGroupHeader")
                                .parent(".singleMatchBetModuleGroup ")
                                .removeClass("removeItem");
                        }
                    });
                }
            }, 300)
        );

        socket.on("delete-live-game", (data) => {
            if (gameId == data.id) {
                const event = new CustomEvent("leaveRoom", {
                    detail: gameId,
                });
                window.dispatchEvent(event);
                window.location.href = "#/InPlay";
            }
        });

        //socket.emit('connectToRoom', {room: gameId});
        const event = new CustomEvent("addToRoom", {
            detail: gameId,
        });
        window.dispatchEvent(event);

        socket.on("new-coefs", (res) => {
            if (res.game_id == gameId) {
                const userGroup = getUserGroup();
                res.coefs.forEach((data) => {

                    data = transformSingleCoef(data, userGroup);

                    let div = document.querySelector(`[bet-id="${data.coef_id}"]`);
                    const span = document.getElementsByClassName(data.coef_id + "-span")[0];

                    if (!div) {
                        hasChanged = false;
                    }
                    if (span && !div) {
                        return;
                    }
                    
                    if (div) {
                        div.innerHTML = getInsideSingleColumn(data.market_option_name, data.odd);
                        document.querySelector(`[bet-id="${data.coef_id}"]`).setAttribute("match-odd", (Math.floor((parseFloat(data.odd) + Number.EPSILON) * 100) / 100).toFixed(2));
                    } else {
                        let market = document.getElementById(data.market_id);
                        if (!market) {
                            market = document.getElementsByClassName(data.market_id);
                            if (market && market.length > 0) {
                                market = market[0]
                            };
                        }
                        // let marketContent = document.getElementById(
                        //   data.market_id + "-content"
                        // );
                        const newSingleCoefTemplate = getSingleColumnModule(
                            {
                                home_team: groupMatchHomeName,
                                away_team: groupMatchAwayName,
                                market_option: data.market_option_name,
                                market: data.market_id,
                                odd: data.odd,
                                id: data.coef_id,
                                market_name: data.market_name,
                            },
                            { id: data.game_id }
                        );
                        if (!market) {
                            if (data.odd != "1.00") {
                                let mainContainer = document.getElementById(`${gameId}-content`);
                                if (mainContainer) {
                                    mainContainer.innerHTML += `<div class="singleMatchBetModuleGroup" id=${data.market_id}>
                                        <div class="singleMatchBetModuleGroupHeader">
                                            <span class="titleMarketSearch">${_t(data.market_name)}</span>
                                        </div>
                                        <div class="singleMatchBetModuleGroupContent">
                                            ${newSingleCoefTemplate}
                                        </div>
                                    </div>`;
                                }
                            } else {
                                let div = document.getElementsByClassName(data.coef_id)[0];
                                if (div) {
                                    div.innerHTML = getInsideSingleColumn(data.market_option_name, data.odd);
                                    document.getElementsByClassName(data.coef_id)[0].setAttribute("match-odd", (Math.floor((parseFloat(data.odd) + Number.EPSILON) * 100) / 100).toFixed(2));
                                }
                            }
                        } else {
                            if (market && market.getElementsByClassName) {
                                const marketContent = market.getElementsByClassName("singleMatchBetModuleGroupContent");
                                if (data.odd != "1.00" && marketContent && marketContent[0]) {
                                    marketContent[0].innerHTML += newSingleCoefTemplate;
                                }
                            }
                        }
                    }
                });
                updateMatch();

                try {
                    if (res.current_result) {
                        const result = res.current_result.split('-');
                        if (result.length === 2) {
                            if ($('.matchVersusName i b:first-child').text() !== result[0]) {
                                $('.matchVersusName i b:first-child').text(result[0]);
                            }
                            if ($('.matchVersusName i b:last-child').text() !== result[1]) {
                                $('.matchVersusName i b:last-child').text(result[1]);
                            }
                        }
                    }
                } catch {
                    console.log('pose')
                }

            }
        });

        if ($(window).width() <= 600) {
            let scrollWidth = 0;
            let scrollMeWidth = 0;

            scrollMeWidth += $("body .singleCategoryTitle").width();
            scrollMeWidth += $("body .matchVersusName").width();

            $(".singleMatchScrolLMeName").width(scrollMeWidth + 15);

            $("body .singleMatchCatBtn").each(function () {
                scrollWidth += $(this).width() + 10;
            });
            $("body .scrollMe").css({
                width: scrollWidth + "px",
            });

            sportFieldId = localStorage.getItem("inplay-sportid");
            if (sportFieldId == 1) {
                var p = $("#iframe");
                var position = p.position();
            }

            let getIframeHeight = $("body #iframe").height();
            $("body #iframe").css({
                height: getIframeHeight + 33 + "px",
            });
            $("body #iframe")
                .parent()
                .css({
                    height: getIframeHeight + 53 + "px",
                    position: "relative",
                });
        }

        // let groupsArray = [];
        // $('body .singleMatchBetModuleGroupHeader').each(function(i, item){
        //   let categoryGroup = $(item).children('span').text();
        //   groupsArray.push(categoryGroup);
        // });
        //
        // const filtered = groupsArray.filter((v, i) => groupsArray.indexOf(v) !== i)
        // const unique = new Set(filtered);
        // console.info(Array.from(unique));

        $("body .singleMatchBetModuleGroup").each(function (e) {
            if (!$(this).attr("id") || $(this).attr("id") == "undefined") {
                $(this).addClass("twoColumn");
            }

            let countChildren = $(this)
                .children(".singleMatchBetModuleGroupContent")
                .children(".singleColumnModule ").length;
            if (countChildren == 2) {
                $(this).addClass("twoColumn");
            }

            if (
                !$(this)
                    .children(".contentMarketNull")
                    .children(".singleMatchBetModuleGroupContent")
                    .children(".singleColumnModule.labelBtn").length == 0
            ) {
                $(this).removeClass("twoColumn");
                $(this)
                    .children(".contentMarketNull")
                    .children(".singleMatchBetModuleGroupContent")
                    .children(".singleColumnModule.labelBtn")
                    .addClass("disabledBtn");
            }
        });

        $("body").addClass("livePage");

        $(".liveMatchButtons .liveMatchBtn").on("click", (e) => {
            e.preventDefault();
            if ($(e.currentTarget).hasClass("active")) {
                return;
            }
            if (e.currentTarget.dataset.show == "live-stream") {
                $(".liveMatchButtons .liveMatchBtn:first-child").removeClass("active");
                $(".singleMatchLiveField .live-field").hide();
                $(".liveMatchButtons .liveMatchBtn:last-child").addClass("active");
                $(".singleMatchLiveField .live-stream").show();
                getLiveStreamLink(e.currentTarget.dataset.link).then((res) => {
                  if (res.success === true) {
                    $("<iframe>", {
                      src: res.url,
                      id: "gameIframe",
                      frameborder: 0,
                      noresize: "noresize",
                      allow: "geolocation 'self'; autoplay 'self'",
                      class: "live-stream-iframe",
                    }).appendTo(".singleMatchLiveField .live-stream");
                  }
                })
            } else {
                $(".liveMatchButtons .liveMatchBtn:last-child").removeClass("active");
                $(".singleMatchLiveField .live-stream").hide().html("");
                $(".liveMatchButtons .liveMatchBtn:first-child").addClass("active");
                $(".singleMatchLiveField .live-field").show();
            }
        });

        $(".newCatHolder .expander").unbind('click');
        $(".newCatHolder .expander").click(async function (e) {
            e.preventDefault();
            $(this).toggleClass('open');
            var $timelineWrapper = $('.singleMatchBetModule .timeline-wrapper');
            if ($(this).hasClass('open')) {
                var gameId = $(this).attr('game-api-id');
                var timeline = await Timeline.render(gameId, true);
                $timelineWrapper.html(timeline);
                Timeline.refreshTimeline(gameId);
            } else {
                $timelineWrapper.html('');
            }
        });

        let scrollMeWidth = 0;
        $('body .scroller').children().each(function (i, item) {
            scrollMeWidth += $(item).outerWidth(true) + 1;
        });

        $('body .scroller').css({
            'width': scrollMeWidth + 'px'
        });

        $('*[data-target="17-module"]').click();

        async function fetchMarketData() {
            const path = `livematch/${request.id}`;
            while (location.hash.includes(path)) {
                try {
                    const response = await makeRequest();
                    const games = response[0];

                    if (games.length > 0) {
                        multipeResults = parseResultList(games[0].result, games[0].result_list, false, sportFieldId);
                        $('.matchVersusName.multiple-results .results').html(multipeResults);
                    }

                    for (const game of games) {
                        if (game.market_id == null) {
                            marketIdShown = false;
                            hasChanged = false;
                            $('body #fixViewOn').html('');
                            $('body .scroller').html('');
                            break;
                        } else {
                            marketIdShown = true;
                            groupMatches = response;
                        }
                    }

                    const lastItem = games[games.length - 1];
                    const currentTime = lastItem ? lastItem.current_minute : '';
                    const gameApiId = lastItem ? lastItem.game_api_id : '';
                    if (currentTime && gameApiId) {
                        Timeline.updateTime(gameApiId, currentTime);
                    }

                    if (marketIdShown && !hasChanged) {
                        fixView();
                    }
                    
                    if (!location.hash.includes('livematch')) {
                        break;
                    }
                    await delays(5000);
                } catch (error) {
                    console.error("Error:", error);
                }
            }
        }

        function delays(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }
        async function makeRequest() {
            return await getLiveMatch(request.id);
        }
        fetchMarketData().catch(err => {
            console.error("Error in fetchMarketData:", err);
        });

        const fixView = async () => {

            hasChanged = true;

            let upDownMarkets = [12, 16];
            let oneTwo = [7, 8, 9, 18];

            let groupMatchView = "";
            let matchView = "";
            let groupMatchDate = "";
            let scrollMeContent = "";
            let result = "";

            try {
                if (groupMatches.length > 0) {
                    liveStreamLink = groupMatches[0][0].stream_url;
                    gameApiID = groupMatches[0][0].game_api_id;
                }
            } catch { }


            if (!groupMatches.length) {
                window.history.back();
                return;
            }

            groupMatchHomeName = `${groupMatches[0][0].home_team}`;
            groupMatchAwayName = `${groupMatches[0][0].away_team}`;
            groupMatchDate = `${groupMatches[0][0].game_date}`;
            result = groupMatches[0][0].result;

            if (!(groupMatches.length == 1 && groupMatches[0].length == 1 && !groupMatches[0][0].odd)) {
                let acc = groupMatches.map(function (item) {
                    return {
                        market_category_id: item[0].market_category_id,
                        mainCategory: item[0].mainCategory,
                        mainCategoryID: item[0].mainCategoryID,
                        marketId: item[0].market_category_id ? -1 : item[0].market_id,
                    };
                });

                const uniqueCategories = [];

                $.each(acc, function (i, el) {
                    const res = uniqueCategories.find((a) => a.market_category_id == el.market_category_id && a.marketId == el.marketId);
                    if (!res) uniqueCategories.push(el);
                });

                uniqueCategories.forEach((category) => {
                    let activeClass = "hidden";
                    // console.log(category);
                    if (category.mainCategory && category.mainCategoryID) {
                        if (scrollMeContent == "") activeClass = "active";
                        if (!scrollMeContent.includes(`data-target="${category.mainCategoryID}-module"`)) {
                            scrollMeContent += `<a class="singleMatchCatBtn ${!category.mainCategoryID || category.mainCategoryID == '33' ? "" : "hidden"}" data-target="${category.mainCategoryID}-module">${_t(category.mainCategory)}</a>`;
                        }
                    }
                    matchView = "";
                    const a = groupMatches.filter((a) => (a[0].market_category_id == category.market_category_id && a[0].market_id == category.marketId) || (a[0].market_category_id == category.market_category_id && category.marketId == -1));

                    let counter = a[0].length;
                    if (a[0][0].special_value && a[0][0].special_value != "") {
                        counter += 1;
                    }
                    let classDescription = "";
                    switch (counter) {
                        case 1:
                            classDescription = "oneColumns";
                            break;
                        case 2:
                            classDescription = "twoColumns";
                            break;
                        case 3:
                            classDescription = "threeColumns";
                            break;
                        case 4:
                            classDescription = "fourColumns";
                            break;
                        default:
                            break;
                    }
                    if (a.length > 1) {
                        matchView += `<div class="singleHeaderHolderLabel">`;
                        if (a[0][0].special_value && a[0][0].special_value != "") {
                            matchView += `<div class="singleHeaderLabel ${classDescription}"></div>`;
                        }
                        if (a[0][0]) {
                            if (a[0][0].type_of_column == 4) {
                                matchView += `<div class="singleHeaderLabel ${classDescription}">1</div>`;
                            } else if (upDownMarkets.includes(a[0][0].market_category_id)) {
                                matchView += `<div class="singleHeaderLabel ${classDescription}">${_t('Lart')}</div>`;
                            } else if (oneTwo.includes(a[0][0].market_category_id)) {
                                matchView += `<div class="singleHeaderLabel ${classDescription}">${groupMatchHomeName}</div>`;
                            } else {
                                matchView += `<div class="singleHeaderLabel ${classDescription}">${_t('Lart')}</div>`;
                            }
                        }
                        if (a[0][1]) {
                            if (a[0][0].type_of_column == 4) {
                                matchView += `<div class="singleHeaderLabel ${classDescription}">X</div>`;
                            } else if (upDownMarkets.includes(a[0][1].market_category_id)) {
                                matchView += `<div class="singleHeaderLabel ${classDescription}">X</div>`;
                            } else if (oneTwo.includes(a[0][1].market_category_id)) {
                                matchView += `<div class="singleHeaderLabel ${classDescription}">${classDescription == "fourColumns" ? "X" : `${groupMatchAwayName}`}</div>`;
                            } else {
                                matchView += `<div class="singleHeaderLabel ${classDescription}">${classDescription == "fourColumns" ? _t("Saktë") : _t("Poshtë")}</div>`;
                            }
                        }
                        if (a[0][0].type_of_column == 4) {
                            matchView += `<div class="singleHeaderLabel ${classDescription}">2</div>`;
                        } else if (a[0][2]) {
                            matchView += `<div class="singleHeaderLabel ${classDescription}">${classDescription == "fourColumns" && oneTwo.includes(a[0][1].market_category_id) ? `${groupMatchAwayName}` : _t("Poshtë")}</div>`
                        }
                        matchView += ` </div>`;
                    }

                    a.forEach((groupMatch) => {
                        if (groupMatch[0].special_value && groupMatch[0].special_value != "") {
                            if (!groupMatch[0].market.includes("Larte Poshte me Pike") && !groupMatch[0].market.includes("Nr i gameve ne Setin") ) {
                                matchView += `<div class="singleColumnModule labelBtn ${groupMatch[0].special_value == '1.5' ? 'pushMeSecond' : ''} ${groupMatch[0].special_value == '0.5' ? 'pushMeFirst' : ''} ${classDescription}">
                                    <span>${groupMatch[0].special_value}</span>
                                </div>`;
                            }
                        }
                        groupMatch.forEach((match) => {
                            if (match.mainCategoryID == '33' && match.market == 'Numri i Golave ne Ndeshje' && (match.market_option == 'Lart 1.5' || match.market_option == 'Poshte 1.5')) {
                                matchView += `<div class="singleColumnModule bettingBtn pushMeSecond ${classDescription} ${match.id}${match.special_value && match.special_value != "" ? "-span" : ``}" 
                                    match-is-live="1" 
                                    match-market-option="${match.market_option}" 
                                    match-market="${match.market}" 
                                    match-home-name="${match.home_team}" 
                                    match-away-name="${match.away_team}"
                                    match-odd="${(Math.floor((parseFloat(match.odd) + Number.EPSILON) * 100) / 100).toFixed(2)}" 
                                    game-id="${request.id}" 
                                    bet-id="${match.id}">
                                        ${match.special_value && match.special_value != "" ? "" : `<span>${_t(match.market_option)}</span>`}
                                        <span>${(Math.floor((parseFloat(match.odd) + Number.EPSILON) * 100) / 100).toFixed(2)}</span>
                                </div>`;
                            } else if (match.mainCategoryID == '33' && match.market == 'Numri i Golave ne Ndeshje' && (match.market_option == 'Lart 0.5' || match.market_option == 'Poshte 0.5')) {
                                matchView += `<div class="singleColumnModule bettingBtn pushMeFirst ${classDescription} ${match.id}${match.special_value && match.special_value != "" ? "-span" : ``}" 
                                    match-is-live="1" match-market-option="${match.market_option}" 
                                    match-market="${match.market}" 
                                    match-home-name="${match.home_team}" 
                                    match-away-name="${match.away_team}" 
                                    match-odd="${(Math.floor((parseFloat(match.odd) + Number.EPSILON) * 100) / 100).toFixed(2)}" 
                                    game-id="${request.id}" 
                                    bet-id="${match.id}">
                                        ${match.special_value && match.special_value != "" ? "" : `<span>${_t(match.market_option)}</span>`}
                                        <span>${(Math.floor((parseFloat(match.odd) + Number.EPSILON) * 100) / 100).toFixed(2)}</span>
                                </div>`;
                            } else {
                                matchView += `<div class="singleColumnModule bettingBtn ${classDescription} ${match.id}${match.special_value && match.special_value != "" ? "-span" : ``}" 
                                    match-is-live="1" 
                                    match-market-option="${match.market_option}" 
                                    match-market="${match.market}" 
                                    match-home-name="${match.home_team}" 
                                    match-away-name="${match.away_team}" 
                                    match-odd="${(Math.floor((parseFloat(match.odd) + Number.EPSILON) * 100) / 100).toFixed(2)}" 
                                    game-id="${request.id}" 
                                    bet-id="${match.id}">
                                    ${match.market.includes("Larte Poshte me Pike") || match.market.includes("Nr i gameve ne Setin") ?
                                        (match.special_value && (match.special_value !== "" && match.special_value !== null) ? `<span>${_t(match.market_option)}</span>` : `<span>${_t(match.market_option)}</span>`) :
                                        (match.special_value && match.special_value != "" ? "" : `<span>${_t(match.market_option)}</span>`)
                                    }
                                    <span>${(Math.floor((parseFloat(match.odd) + Number.EPSILON) * 100) / 100).toFixed(2)}</span>
                                </div>`;
                            }
                        });
                        if (!category.market_category_id) {
                            groupMatchView +=
                                `<div class="singleMatchBetModuleGroup ${!category.mainCategoryID || category.mainCategoryID == '33' ? "active" : "hidden"}"  data-content="${category.mainCategoryID}-module"  id="${groupMatch[0].market_id}">
                                        <div class="singleMatchBetModuleGroupHeader">
                                            <span class="titleMarketSearch">${_t(groupMatch[0].market)}</span>
                                        </div>
                                    <div class="singleMatchBetModuleGroupContent">
                                        ${matchView}
                                    </div>
                                </div>`;
                            matchView = "";
                        }
                    });

                    if (category.market_category_id && category.market_category_id > 0) {
                        const uniqueMarkets = groupMatches.filter((a) => a && a[0] && a[0].market_category_id == category.market_category_id).map((item) => item[0].market_id);
                        const marketsClass = uniqueMarkets.join(" ");
                        groupMatchView += `<div class="singleMatchBetModuleGroup ${marketsClass} ${activeClass} ${a[0][0].market == 'Numri i Golave ne Ndeshje' ? 'fixThis' : ''}"  data-content="${a[0][0].mainCategoryID}-module">
                            <div id="${a[0][0].market_id}" class="contentMarketNull"> 
                                <div class="singleMatchBetModuleGroupHeader">
                                    <span class="titleMarketSearch">${_t(a[0][0].market)}</span>
                                </div>
                                <div class="singleMatchBetModuleGroupContent">
                                    ${matchView}
                                </div>
                            </div>
                        </div>`;
                    }
                });
            }

            $('body #fixViewOn').html(groupMatchView);
            $('body .scroller').html(scrollMeContent);

            $('body .fixThis .singleMatchBetModuleGroupContent').each(function (i, item) {
                $(item).children('.pushMeFirst').wrapAll('<div class="groupRender first"></div>');
                $(item).children('.pushMeSecond').wrapAll('<div class="groupRender second"></div>');
                $(item).children('.pushMeSecond').wrapAll('<div class="groupRender third"></div>');
            });
            $('body .fixThis .singleMatchBetModuleGroupContent').each(function (i, item) {
                let firstItemGroup = $(item).children('.first');
                let secondItemGroup = $(item).children('.second');
                let thirdItemGroup = $(item).children('.third');
                let titleHeader = $(item).children('.singleHeaderHolderLabel');

                $(item).children('.first').remove();
                $(item).children('.second').remove();
                $(item).children('.third').remove();

                $(item).prepend(thirdItemGroup);
                $(item).prepend(secondItemGroup);
                $(item).prepend(firstItemGroup);
                $(item).prepend(titleHeader);
            });

            $("body .singleMatchBetModuleGroup").each(function (e) {
                if (!$(this).attr("id") || $(this).attr("id") == "undefined") {
                    $(this).addClass("twoColumn");
                }

                let countChildren = $(this).children(".singleMatchBetModuleGroupContent").children(".singleColumnModule ").length;
                if (countChildren == 2) {
                    $(this).addClass("twoColumn");
                }
                if (!$(this).children(".contentMarketNull").children(".singleMatchBetModuleGroupContent").children(".singleColumnModule.labelBtn").length == 0) {
                    $(this).removeClass("twoColumn");
                    $(this).children(".contentMarketNull").children(".singleMatchBetModuleGroupContent").children(".singleColumnModule.labelBtn").addClass("disabledBtn")
                }
            });

            $(".newCatHolder .expander").unbind('click');
            $(".newCatHolder .expander").click(async function (e) {
                e.preventDefault();
                $(this).toggleClass('open');
                var $timelineWrapper = $('.singleMatchBetModule .timeline-wrapper');
                if ($(this).hasClass('open')) {
                    var gameId = $(this).attr('game-api-id');
                    var timeline = await Timeline.render(gameId, true);
                    $timelineWrapper.html(timeline);
                    Timeline.refreshTimeline(gameId);
                } else {
                    $timelineWrapper.html('');
                }
            });

            setTimeout(()=>{
                let scrollMeWidthss = 0;
                $('body .scroller').children().each(function (i, item) {
                    scrollMeWidthss += $(item).outerWidth(true);
                });
                $('body .scroller').css({
                    'width': scrollMeWidthss + 10 + 'px'
                });
            },50)
            if( lastActive === undefined ){
                $(`body .singleMatchCatBtn:first-child`).click();
            }else {
                $(`body .singleMatchCatBtn[data-target="${lastActive}"]`).click();
            }
        }
    },
    on_unload: async (socket) => {
        console.log('asdasd');
        socket.emit('leaveRoom', { room: gameId });
        const event = new CustomEvent("leaveRoom", {
            detail: gameId,
        });
        window.dispatchEvent(event);
    },
};

export default LiveMatch;
